import "./Tabs.css"

type TableTabsProps = {
    children: JSX.Element | JSX.Element[]
}

const Tabs = ({ children }: TableTabsProps) => <div className="tabs">{children}</div>

export default Tabs
